import type { CreateDreamRequest } from '../services/dreamService'

/**
 * The create form's vocabulary and its one mapping to the API (Dreams UX pass
 * 2026-09-06). A title is enough; nothing optional is sent when it was not said.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DreamFormData = Record<string, any>

export function dreamFormToPayload(form: DreamFormData): CreateDreamRequest {
  const areas: string[] = Array.isArray(form.life_areas) ? form.life_areas.map(String).filter(Boolean) : []
  return {
    title: String(form.title || '').trim(),
    priority: (form.priority || 'medium') as CreateDreamRequest['priority'],
    life_areas: areas.length ? areas : undefined,
    life_area: areas.length ? areas[0] : undefined,
    description: form.description?.trim?.() || undefined,
    target_date: form.target_date ? String(form.target_date).slice(0, 10) : undefined,
  }
}
